import React, { useState } from 'react';
import { Button, Card, Collapse, Typography, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import AxiosCaller from '../../authenticatie/AxiosCaller';
import { useNavigate } from 'react-router-dom';
import './VoorstelCard.css';
import { openNotificationSuccess, openNotificationError } from '../Notification/Notification';
import { Role } from '../../Services/auth.service';
import GetUserInfo from '../../Screens/authenticatie/GetUserInfo';
const { Panel } = Collapse;
const { Text } = Typography;
const currentUser = GetUserInfo();
const VoorstelCard = ({ voorstel, updateList, isKookGeschiedenis }) => {
    const { get, del } = AxiosCaller();
    const navigate = useNavigate();
    const [activePanels, setActivePanels] = useState([]);
    const removeVoorstel = async () => {

            try {
                await del('/Voorstel/' + voorstel._id);
                updateList();
                openNotificationSuccess("voorstel succesvol verwijderd!")
            } catch (error) {
                console.error(error);
                openNotificationSuccess("Fout bij verwijderen voorstel",error)
            }
    };

  const editVoorstel = async () => {
        try {
            const response = await get('/voorstel/' + voorstel._id);

            const updatedData = {
            ...response.data,
            isEdit: true,
            };
          console.info("role accessed:", !!currentUser?.rol);

            

            
            if (currentUser.rol === Role.Leerkracht) {
                navigate('/leerKracht', { state: updatedData });
            } else if (
                currentUser.rol === Role.Besteller ||
                currentUser.rol === Role.Gebruikersbeheerder
            ) {
                navigate('/admin/bestelling/leerKracht', { state: updatedData });
            }else{
                openNotificationError("Probeer opnieuw");
            }
          

            
           
        } catch (error) {
            console.error(error);
            openNotificationError("Fout bij aanpassen voorstel", error);
        }
    };


    return (
        
        <Card
            className={`voorstelcard-card ${voorstel.isGevalideerd || isKookGeschiedenis? 'voorstelcard-validated-card' : 'voorstelcard-not-validated-card'}`}
            title={
                <div className="voorstelcard-card-header">
                    <div className="voorstelcard-card-header-left">
                        <div className="voorstelcard-card-header-item">
                            <Text strong>Kook datum:</Text> 
                            <Text>{new Date(voorstel.kookDatum).toLocaleDateString('nl-NL')}</Text>
                        </div>
                        <div className="voorstelcard-card-header-item">
                            <Text strong>Klas:</Text> <Text>{voorstel.klas.naam}</Text>
                        </div>
                        <div className="voorstelcard-card-header-item">
                            <Text strong>Aantal:</Text> <Text>{voorstel.aantalStudenten} leerlingen</Text>
                        </div>
                        <div className="voorstelcard-card-header-item">
                            <Text strong>Leerkracht:</Text> <Text>{voorstel.leerkracht.naam}</Text>
                        </div>
                    </div>
                    <div className="voorstelcard-card-header-right">
                        {voorstel.isGevalideerd || isKookGeschiedenis ? (
                            <Button icon={<CheckCircleOutlined />} type="link" disabled>Verwerkt</Button>
                        ) : (
                            <>
                                <Button icon={<EditOutlined />} onClick={editVoorstel} type="link"></Button>
                                
                                <Popconfirm title="Weet je het zeker?" onConfirm={removeVoorstel}>
                                <DeleteOutlined className='delete-button'/>
                                </Popconfirm>

                                      
                            </>
                        )}
                    </div>
                    <p>{isKookGeschiedenis}</p>
                </div>
                
            }
        >
            {voorstel.opmerking && <p><strong>Opmerking:</strong> {voorstel.opmerking}</p>}
            <div className="voorstelcard-card-content">
                <div className="voorstelcard-dishes-container">
                    {voorstel.voorgerecht?.producten?.length > 0 && (
                        <div className="voorstelcard-dish">
                            <Collapse activeKey={activePanels} onChange={setActivePanels}>
                                <Panel header={`Voorgerecht: ${voorstel.voorgerecht.naam}`} key="1">
                                    {voorstel.voorgerecht.producten.map((product, index) => (
                                        <div key={index}>
                                           {isKookGeschiedenis ? (
                                                <p>
                                                    <Text strong>{product.product}</Text>:  
                                                    <Text>{product.aantal.toFixed(1)} {product.eenheid}</Text>
                                                </p>
                                            ) : (
                                                <p>
                                                    <Text strong>{product.product?.naam}</Text>:  
                                                    <Text>{product.aantal.toFixed(1)} {product.product?.eenheid?.naam}</Text>
                                                </p>
                                            )}

                                           
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </div>
                    )}

                    {voorstel.hoofdgerecht?.producten?.length > 0 && (
                        <div className="voorstelcard-dish">
                            <Collapse activeKey={activePanels} onChange={setActivePanels}>
                                <Panel header={`Hoofdgerecht: ${voorstel.hoofdgerecht.naam}`} key="2">
                                    {voorstel.hoofdgerecht.producten.map((product, index) => (
                                        <div key={index}>
                                            {isKookGeschiedenis ? (
                                                <p>
                                                    <Text strong>{product.product}</Text>:  
                                                    <Text>{product.aantal.toFixed(1)} {product.eenheid}</Text>
                                                </p>
                                            ) : (
                                                <p>
                                                    <Text strong>{product.product?.naam}</Text>:  
                                                    <Text>{product.aantal.toFixed(1)} {product.product?.eenheid?.naam}</Text>
                                                </p>
                                            )}

                                             </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </div>
                    )}

                    {voorstel.nagerecht?.producten?.length > 0 && (
                        <div className="voorstelcard-dish">
                            <Collapse activeKey={activePanels} onChange={setActivePanels}>
                                <Panel header={`Nagerecht: ${voorstel.nagerecht.naam}`} key="3">
                                    {voorstel.nagerecht.producten.map((product, index) => (
                                        <div key={index}>
                                      {isKookGeschiedenis ? (
                                        <p>
                                            <Text strong>{product.product}</Text>:  
                                            <Text>{product.aantal.toFixed(1)} {product.eenheid}</Text>
                                        </p>
                                    ) : (
                                        <p>
                                            <Text strong>{product.product?.naam}</Text>:  
                                            <Text>{product.aantal.toFixed(1)} {product.product?.eenheid?.naam}</Text>
                                        </p>
                                    )}

                                             </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default VoorstelCard;
